import { render } from "./PaginationWithoutItemsPerPage.vue?vue&type=template&id=510125c4&scoped=true&lang=pug"
import script from "./PaginationWithoutItemsPerPage.vue?vue&type=script&lang=js"
export * from "./PaginationWithoutItemsPerPage.vue?vue&type=script&lang=js"

import "./PaginationWithoutItemsPerPage.vue?vue&type=style&index=0&id=510125c4&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-510125c4"]])

export default __exports__